var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('base-page-layout',{attrs:{"title":"Produtos impulsionadores"}},[_c('step1-sales-strategy')],1)}
var staticRenderFns = []

export { render, staticRenderFns }